// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3nSoC","active":"NavigationItem_active__3yfRw"};